<template>
  <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div>
  <form @submit.prevent="handleFilters">
    <div class="row filter-row">
      <div class="col-sm-6 col-md-2">
        <div
          class="input-block mb-3 form-focus"
          :class="{ focused: isFocused }"
        >
          <input
            type="text"
            :style="`${
              filters.hcm_id && 'border-bottom: var(--primary-color) 2px solid;'
            }`"
            class="form-control floating"
            v-model="filters.hcm_id"
            @focus="isFocused = true"
            @blur="isFocused = hcm_id !== ''"
          />
          <label class="focus-label">Employee ID</label>
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div
          class="input-block mb-3 form-focus"
          :class="{ focused: isFocusedOn }"
        >
          <input
            type="text"
            class="form-control floating"
            :style="`${
              filters.name && 'border-bottom: var(--primary-color) 2px solid;'
            }`"
            v-model="filters.name"
            @focus="isFocusedOn = true"
            @blur="isFocusedOn = name !== ''"
          />
          <label class="focus-label">Employee Name</label>
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mb-3 form-focus focused">
          <input
            type="date"
            class="form-control floating"
            :style="`${
              filters.from_date &&
              'border-bottom: var(--primary-color) 2px solid;'
            }`"
            v-model="filters.from_date"
            @focus="isFocusedFromDate = true"
            @blur="isFocusedFromDate = from_date !== ''"
          />
          <label class="focus-label">Date</label>
        </div>
      </div>
      <!-- <div class="col-sm-6 col-md-2">
        <div class="input-block mb-3 form-focus focused">
          <input
            type="date"
            class="form-control floating"
            :style="`${
              filters.to_date &&
              'border-bottom: var(--primary-color) 2px solid;'
            }`"
            v-model="filters.to_date"
            @focus="isFocusedToDate = true"
            @blur="isFocusedToDate = to_date !== ''"
          />
          <label class="focus-label">To date</label>
        </div>
      </div> -->
      <div class="col-md-3"></div>
      <div class="d-flex col-sm-6 col-md-3 gap-2">
        <button
          type="submit"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="handleFilters"
        >
          Search
        </button>
        <button
          type="button"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="resetAllFilters"
        >
          Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      select2: null,
      filters: {
        hcm_id: "",
        name: "",
      },
      isFocused: false,
      isFocusedOn: false,
      isFocusedFromDate: false,
      isFocusedToDate: false,
      searched: false,
    };
  },
  props: {},
  methods: {
    handleFilters(value) {
      //console.log(JSON.stringify(this.filters));
      this.searched = true;
      this.$emit("apply-filters", this.filters);
      // Perform any action on change
    },

    handleClearOneFilter(fileName) {
      this.filters[fileName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el,
      ).length;
      if (this.searched) {
        this.$emit("apply-filters", this.filters);
      }
      if (!filtersHasProperty) {
        this.searched = false;
      }
    },

    resetAllFilters() {
      // Reset all filter values to empty strings
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });

      // Emit updated filters
      this.$emit("apply-filters", this.filters);

      // Reset search state
      this.searched = false;
    },

    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        hcm_id: "",
        name: "",
      };
      this.searched = false;
    },
  },
  async created() {
    this.searched = false;
  },

  computed: {
    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el,
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>
